import { Box, Container, Grid, Typography } from '@mui/material';

const StatsSection = () => {
  return (
    <Box className="countbglinear">
      <Box className="bgImgcount" sx={{ py: { xs: 4, md: 6 } }}>
        <Container className="p-0 mobilepadding">
          <Grid container spacing={2} justifyContent="center">
            {[
              { value: '100+', label: 'Shoots' },
              { value: '30+', label: 'YT Channel Management' },
              { value: '7M+', label: 'Reach' },
              { value: '11B+', label: 'Impressions' },
              { value: '10K+', label: 'Influencer Network' },
              { value: '10+', label: 'Trusted by Global Brands' },
            ].map((item, index) => (
              <Grid key={index} item xs={12} sm={4} md={2} sx={{padding:'0px'}}>
                <Box textAlign="center">
                  <Typography className="font300 fontSize48 colorWhite">
                    {item.value}
                  </Typography>
                  <Typography className="font600 fontSize16 colorWhite">
                    {item.label}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </Box>
  );
};

export default StatsSection;
